import styled from 'styled-components';
import { Icon } from '../icon/Icon';

interface CheckboxCircleProps {
  isSelected: boolean;
}

export const CheckboxCircle = ({ isSelected }: CheckboxCircleProps) => {
  return (
    <Circle isActived={isSelected}>
      {isSelected ? (
        <Icon name={'CheckBox_Blue'} width={10} height={8} />
      ) : (
        <Icon name={'CheckBox_Grey'} width={10} height={8} />
      )}
    </Circle>
  );
};

const Circle = styled.div<{ isActived: boolean }>`
  width: 16px;
  height: 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  padding: 2px;
  gap: 8px;

  border-radius: 50px;
  border: ${(props) => !props.isActived && '1px solid var(--Light-Scheme-Monochrome-grey30, #d5d5e3)'};
  background: ${(props) => (props.isActived ? '#445eff' : '#fff')};
`;
